<template>
  <button ref="button" v-if="type === 'button'" @click.prevent="$emit('buttonClick')" class="button-primary" :class="[disabled ? 'button-primary--disabled': null, fullWidth ? 'button-primary--full-width' : null, theme ? 'button-primary--' + theme : null, isLoading ? 'button-primary--loading' : null, loaded ? 'button-primary--loaded' : null]">
    <template v-if="isLoading && !loaded">
      Saving...
    </template>
    <template v-else-if="loaded">
      <span>Saved</span>
      <svg class="button-primary__tick" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 8.375L6 12.5L14 1.5" stroke="#64DCBE" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </template>
    <template v-else>
      {{ title }}
    </template>
  </button>
  <a v-else-if="type === 'link'" :href="link" class="button-primary" :class="{'button-primary--disabled': disabled, 'button-primary--full-width': fullWidth}">
    {{ title }}
  </a>
  <router-link v-else-if="type === 'router'" :to="link" class="button-primary" :class="{'button-primary--disabled': disabled, 'button-primary--full-width': fullWidth}">
    {{ title }}
  </router-link>
</template>

<script>

export default {
  name: 'ButtonPrimary',
  data: () => ({
    isLoading: false,
    loaded: false
  }),
  components: {
  },
  computed: {
  },
  props: {
    title: { type: String , required: true, default: null },
    disabled: { type: Boolean , required: false, default: false },
    fullWidth: { type: Boolean , required: false, default: false },
    link: { type: String , required: false, default: null },
    type: { type: String , required: false, default: 'button' }, // button / link / router
    theme: { type: String , required: false, default: null }, // docusign
    loading: { type: Boolean , required: false, default: false }, // docusign
  },
  watch: {
    loading: {
      handler (value) {
        var self = this
        if (value ) {
          this.isLoading = value
        } else if (!value && this.isLoading) {
          setTimeout (() => {
            self.loaded = true
          }, 1000)
          setTimeout (() => {
            self.isLoading = value
            self.loaded = value
            self.$refs.button.blur()
          }, 3000)
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../scss/global/includes";

.button-primary {
    width: auto;
    background: $primary;
    color: $white;
    height: 47px;
    padding: 10px 15px;
    min-width: 122px;
    @include responsive-text-size('Button--12--BOLD');
    border-radius: 4px;
    @include ease-fast;
    text-align: center;
    display: inline-flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    position: relative;

    &.button-primary--full-width {
      width: 100%;
    }

    &.button-primary--docusign {
      background: $white;
      border: 1px solid #000000;
      color: #000000;
      text-transform: initial;

      &:hover {
        background: $grey-m;
        color: #000000;
      }

      &:focus {
        background: $light-grey;
        border: 1px solid #000000;
        color: #000000;  
      }

      &:disabled, &.button-primary--disabled {
        background: $white;
        opacity: 0.4;
        color: #000000;
        pointer-events: none;
      }
    }

    &:hover {
      background: $primary-faded;
      color: $white;    
    }

    &:disabled, &.button-primary--disabled {
      background: $primary-faded;
      color: $white;
      pointer-events: none;
    }

    &:focus:not(.focus-hidden) {
      background: $primary-faded;
      color: $primary;   
    }

    .button-primary__tick {
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translateY(-50%);
    }

    &.button-primary--loaded {
      color: $light-green!important;
      border: 1px solid $light-green!important;
      background: $white!important;
      span {
      }
    }


}
</style>
